import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {Offer} from '../types';

interface IndexPageHeaderProps {
    selectedRecords: Offer[];
    setSelectedRecords: (records: Offer[]) => void;
}

const useTools = (selectedRecords: Offer[], setSelectedRecords: (records: Offer[]) => void) => {

    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    tools.push(<ReloadRecordsButton key='reload'/>);

    if (allowedActions.includes('DeleteOffer')) {
        tools.push(<DeleteRecordButton key='delete' selectedRecords={selectedRecords}
                                       setSelectedRecords={setSelectedRecords}/>);
    }

    if (allowedActions.includes('CreateOffer')) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = ({selectedRecords, setSelectedRecords}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get('Offers')}
            tools={useTools(selectedRecords, setSelectedRecords)}
        />
    );
};
